export enum ResponsibilityType {
	Owner = 'owner'
}
